(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ke-cart"]) return;
  try {
    
async function keUpdateCartDiscounts(root, removeCode) {
  if (root.dataset.busy === 'true') return;
  const input = root.querySelector('[data-ke-discount-input]');
  const entered = input.value.trim();
  if (removeCode === undefined && !entered) {
    input.focus();
    return;
  }
  const currentCodes = Array.from(root.querySelectorAll('[data-ke-discount-code]'), item => item.dataset.keDiscountCode);
  const codes = removeCode === undefined ? [...new Set([...currentCodes, entered])] : currentCodes.filter(code => code !== removeCode);
  const error = root.querySelector('[data-ke-discount-error]');
  const controls = Array.from(root.querySelectorAll('button'));
  root.dataset.busy = 'true';
  root.setAttribute('aria-busy', 'true');
  input.readOnly = true;
  controls.forEach(button => { button.disabled = true; });
  error.hidden = true;
  try {
    const response = await fetch(root.dataset.updateUrl, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ discount: codes.join(',') })
    });
    if (!response.ok) throw new Error();
    const cart = await response.json();
    const rejected = removeCode === undefined && !cart.discount_codes?.some(code => code.code.toLowerCase() === entered.toLowerCase() && code.applicable);
    if (rejected) {
      error.textContent = root.dataset.invalid;
      error.hidden = false;
      input.focus();
      return;
    }
    window.location.reload();
  } catch {
    error.textContent = root.dataset.failed;
    error.hidden = false;
  } finally {
    root.dataset.busy = 'false';
    root.removeAttribute('aria-busy');
    input.readOnly = false;
    controls.forEach(button => { button.disabled = false; });
  }
}
document.addEventListener('click', event => {
  const apply = event.target.closest('[data-ke-discount-apply]');
  const remove = event.target.closest('[data-ke-discount-remove]');
  const control = apply || remove;
  if (!control) return;
  keUpdateCartDiscounts(control.closest('[data-ke-cart-discounts]'), remove ? remove.dataset.keDiscountRemove : undefined);
});
document.addEventListener('keydown', event => {
  if (event.key !== 'Enter' || !event.target.matches('[data-ke-discount-input]')) return;
  event.preventDefault();
  keUpdateCartDiscounts(event.target.closest('[data-ke-cart-discounts]'));
});
document.addEventListener('submit', async event => {
  if (!window.location.hostname.endsWith('.shopifypreview.com') || !event.target.matches('.ke-cart-form') || event.submitter?.name !== 'checkout') return;
  event.preventDefault();
  const root = event.target.closest('[data-ke-cart-discounts]');
  if (root.dataset.busy === 'true') return;
  const error = root.querySelector('[data-ke-discount-error]');
  const controls = Array.from(root.querySelectorAll('button'));
  const codes = Array.from(root.querySelectorAll('[data-ke-discount-code]'), item => item.dataset.keDiscountCode);
  const updates = Array.from(event.target.querySelectorAll('[name="updates[]"]'), input => Number(input.value));
  root.dataset.busy = 'true';
  root.setAttribute('aria-busy', 'true');
  controls.forEach(button => { button.disabled = true; });
  error.hidden = true;
  try {
    const response = await fetch(root.dataset.updateUrl, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ updates, discount: codes.join(',') })
    });
    if (!response.ok) throw new Error();
    const cart = await response.json();
    if (!cart.items.length) {
      window.location.reload();
      return;
    }
    const quantities = new Map();
    cart.items.forEach(item => quantities.set(item.variant_id, (quantities.get(item.variant_id) || 0) + item.quantity));
    const lines = Array.from(quantities, ([variant, quantity]) => `${variant}:${quantity}`).join(',');
    const checkout = new URL(`${root.dataset.checkoutCartUrl}/${lines}`);
    const applicableCodes = (cart.discount_codes || []).filter(code => code.applicable).map(code => code.code);
    checkout.searchParams.set('discount', applicableCodes.join(','));
    window.location.assign(checkout.href);
  } catch {
    error.textContent = root.dataset.failed;
    error.hidden = false;
    root.dataset.busy = 'false';
    root.removeAttribute('aria-busy');
    controls.forEach(button => { button.disabled = false; });
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ke-product"]) return;
  try {
    
function keSetProductImage(root, src, alt) {
  if (!src) return;
  const image = root.querySelector('.ke-primary-image');
  image.removeAttribute('srcset');
  image.src = src;
  image.alt = alt || '';
  root.querySelectorAll('[data-ke-thumbnail]').forEach(button => {
    button.setAttribute('aria-pressed', String(button.dataset.keImage === src));
  });
}
document.addEventListener('click', function(event) {
  const thumbnail = event.target.closest('[data-ke-thumbnail]');
  if (!thumbnail || thumbnail.hidden) return;
  keSetProductImage(thumbnail.closest('[data-ke-product]'), thumbnail.dataset.keImage, thumbnail.dataset.keAlt);
});
document.addEventListener('change', function(event) {
  const input = event.target;
  if (!input.matches('[data-ke-product] input[name="id"]')) return;
  const root = input.closest('[data-ke-product]');
  root.querySelector('[data-ke-price]').textContent = input.dataset.kePrice;
  if (input.dataset.keColor) {
    root.querySelector('[data-ke-gallery-color]').dataset.keGalleryColor = input.dataset.keColor;
    root.querySelectorAll('[data-ke-thumbnail]').forEach(thumbnail => {
      thumbnail.hidden = thumbnail.dataset.keColor !== input.dataset.keColor;
    });
  }
  keSetProductImage(root, input.dataset.keImage, input.dataset.keAlt);
  const button = root.querySelector('[data-ke-add]');
  if (button) {
    button.disabled = input.dataset.keAvailable !== 'true';
    button.textContent = button.disabled ? button.dataset.sold : button.dataset.label;
  }
  const url = new URL(window.location.href);
  url.searchParams.set('variant',input.value);
  history.replaceState(null,'',url);
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
